export default "__VITE_ASSET__28be9c23__"